const i = (r = {}) => typeof r != "object" || r === null || Array.isArray(r) ? {} : Object.entries(r).reduce((e, [n, t]) => t == null || t === "" ? e : {
  ...e,
  [n]: t
}, {});
export {
  i as filterObject
};
